<template>
  <div>
    <v-row>
      <v-col md="12" class="pb-1">
        <!-- <br v-if="!CajaInstalacion" /> -->

        <v-btn v-if="!CajaInstalacion" class="mb-4" color="primary" @click="showModal = true"
          >Ver Ticket</v-btn
        >
        <v-btn
          v-if="!CajaInstalacion && dataEdit._l"
          color="light blue"
          class="ma-1"
          @click="showCambiosForm = true"
          dark
          >Ver Cambios</v-btn
        >
        <v-tabs v-model="mtabsmodel" slider-color="blue">
          <v-tab> Sistema </v-tab>
          <v-tab v-if="!CajaInstalacion"> Capturado </v-tab>
          <v-tab v-if="ventas"> Tickets </v-tab>
        </v-tabs>
        <v-tabs-items v-model="mtabsmodel">
          <v-tab-item>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Concepto</th>
                    <th class="text-left">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Fondo Inicial</td>
                    <td>
                      {{
                        $pgsHelper.formatNumber(
                          baseData.Cnts.Fdo[currencyClass.getCurrencyDefault()],
                        )
                      }}
                      {{ currencyClass.getCurrencyDefault() }}
                    </td>
                  </tr>
                  <tr>
                    <td>Cambio</td>
                    <td>
                      {{
                        baseData.Cnts.Cmb
                          ? $pgsHelper.formatNumber(
                              baseData.Cnts.Cmb[
                                currencyClass.getCurrencyDefault()
                              ],
                            )
                          : 0
                      }}
                      {{ currencyClass.getCurrencyDefault() }}
                    </td>
                  </tr>
                  <template v-for="(item, index) in contadores">
                    <tr v-if="baseData.Cnts.Ttl[item] != 0" :key="index">
                      <td>{{ getPayMethods[index].Nombre }}</td>
                      <td>
                        {{ $pgsHelper.formatNumber(baseData.Cnts.Ttl[index]) }}
                      </td>
                    </tr>
                  </template>

                  <tr v-for="(item, key) in propinas" :key="key + 10000">
                    <td>Propina {{ getPayMethods[key].Nombre }}</td>
                    <td>
                      {{ $pgsHelper.formatNumber(item) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-tab-item>
          <v-tab-item>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th width="50%" class="text-left">Concepto</th>
                    <th width="50%" class="text-left">Valor</th>
                    <!-- <th></th> -->
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, key) in baseData.Montos">
                    <tr
                      v-if="
                        (key != 'CARDS_MXN') &
                        (key != 'CARDS_USD') &
                        (key != 'totalMXN') &
                        (key != 'totalUSD') &
                        (key != 'totalGeneral') &
                        (key != 'MACA_MXN') &
                        (key != 'VISA_XXX') &
                        (key != 'MACA_USD') &
                        (key != 'VISA_USD') &
                        (key != 'MACA_BTC') &
                        (key != 'VISA_BTC') &
                        (key != 'MACA_XXX') &
                        (key != 'VISA_MXN')
                      "
                      :key="key"
                    >
                      <td>{{ key }}</td>
                      <td>
                        {{ $pgsHelper.formatNumber(item.Total) }}
                      </td>
                      <td>
                        <v-btn
                          text
                          @click="
                            showEditForm = true;
                            keyModelo = key;
                            inputValor = item.Total;
                          "
                          >Editar</v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
            <v-card>
              <v-btn @click="saveData()" class="my-2" color="green" block dark>
                Guardar
              </v-btn>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="elevation-1 rounded-lg" outlined>
              <div
                class="d-flex flex-column flex-sm-row justify-space-between align-center px-4 pt-4 pb-2 gap-3"
              >
                <v-btn-toggle
                  v-model="ventasFilter"
                  mandatory
                  rounded
                  dense
                  class="mb-3 mb-sm-0"
                  
                >
                  <v-btn value="all" small depressed>Todos</v-btn>
                  <v-btn value="venta" small depressed>Ventas</v-btn>
                  <v-btn value="devolucion" small depressed>Devoluciones</v-btn>
                </v-btn-toggle>

                <v-text-field
                  v-model="searchVenta"
                  placeholder="Buscar por clave..."
                  dense
                  outlined
                  hide-details
                  clearable
                  prepend-inner-icon="mdi-magnify"
                  style="max-width: 320px; width: 100%"
                ></v-text-field>
              </div>

              <v-divider></v-divider>

              <v-list dense class="py-0">
                <template v-for="([key, item], index) in filteredVentasEntries">
                  <v-list-item :key="`item-${key}-${index}`" class="px-4">
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-medium">
                        {{ key }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action class="my-1">
                      <v-chip
                        :color="item == 1 ? 'green lighten-5' : 'red lighten-5'"
                        :text-color="
                          item == 1 ? 'green darken-3' : 'red darken-3'
                        "
                        x-small
                        class="font-weight-bold px-3"
                      >
                        {{ item == 1 ? "Venta" : "Devolución" }}
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider
                    v-if="index < filteredVentasEntries.length - 1"
                    :key="`div-${key}-${index}`"
                  ></v-divider>
                </template>

                <v-list-item
                  v-if="filteredVentasEntries.length === 0"
                  class="py-6"
                >
                  <v-list-item-content class="text-center">
                    <v-icon color="grey lighten-1" class="mb-2" large
                      >mdi-magnify-close</v-icon
                    >
                    <div class="text-caption grey--text text--darken-1">
                      No se encontraron resultados
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <modal v-model="showEditForm" :showFooter="false" title="Editar valor">
      <h4 class="mb-1">{{ keyModelo }}</h4>
      <v-text-field
        label="Ingrese valor"
        hide-details="auto"
        type="number"
        v-model="inputValor"
      >
      </v-text-field
      ><v-btn
        small
        color="green"
        dark
        block
        class="mt-2"
        @click="editarValor(keyModelo)"
        >Aceptar</v-btn
      >
    </modal>
    <modal
      :ref="'modalForm'"
      v-model="showModal"
      :showFooter="false"
      title="Ticket Corte"
    >
      <v-btn color="primary" @click="imprimirElemento()">imprimir</v-btn>
      <cortePrint
        ref="corte"
        :dataToTicket="compareCounts.data"
        :getCashierName="baseData.CajeroNombre"
        :propinas="propinasFullData"
        :fecha="baseData.Momento"
      >
      </cortePrint>
    </modal>
    <modal
      v-model="showCambiosForm"
      :showFooter="false"
      title="Registro de cambios"
    >
      <v-simple-table>
        <thead>
          <tr>
            <td>Responsable</td>
            <td>Método de pago</td>
            <td>Tipo</td>
            <td>Fecha</td>
            <td>Antes</td>
            <td>Después</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, index) in logs" :key="index">
            <td>{{ log.responsable }}</td>
            <td>{{ log.cambios.montoModificado }}</td>
            <td>{{ log.cambios.tipo }}</td>
            <td>{{ log.fecha }}</td>
            <td>{{ log.cambios.antes }}</td>
            <td>{{ log.cambios.despues }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import Currency from "../../clases/Currencies.js";
import cortePrint from "./CorteCajaPrint";
import { mapGetters } from "vuex";
/*import MembresiasForm from "../Membresias/FormMembresia.vue";*/

export default {
  name: "CajasTotales",
  components: {
    /*MembresiasForm,
    modal,*/
    cortePrint,
  },
  props: ["dataEdit", "CajaInstalacion"],
  data() {
    return {
      mtabsmodel: "",
      showModal: false,
      showEditForm: false,
      showCambiosForm: false,
      inputValor: "",
      keyModelo: "",
      pagos: Currency.getPagos(),
      monedas: Currency.getCurrencies(),
      currencyClass: Currency,
      ventasFilter: "all",
      searchVenta: "",
    };
  },
  computed: {
    logs() {
      if (this.dataEdit._l) {
        return this.extractChanges(this.dataEdit._l);
      }
      return [];
    },
    ...mapGetters(["getPDVPagosTipos", "getPDVMonedasLista"]),
    contadores() {
      return this.baseData?.Cnts?.Ttl;
    },
    propinas() {
      let data = this.baseData?.Cnts?.Pps ? this.baseData.Cnts.Pps : {};
      return data;
    },
    propinasFullData() {
      let data = this.baseData?.Cnts?.Pps
        ? this.$pgsHelper.cloneObj(this.baseData.Cnts.Pps)
        : {};
      let propinasArray = Object.entries(data);
      let dataProps = {};
      dataProps["CARDS_MXN"] = {
        Cantidad: 0,
        Pago: "CARDS",
        Moneda: "MXN",
        Nombre: "Visa/Mastercard Pesos Mexicanos",
      };
      dataProps["CARDS_USD"] = {
        Cantidad: 0,
        Pago: "CARDS",
        Moneda: "USD",
        Nombre: "Visa/Mastercard Dolar",
      };
      propinasArray.forEach((ele) => {
        if (ele[0] == "VISA_MXN" || ele[0] == "MACA_MXN") {
          dataProps["CARDS_MXN"].Cantidad =
            dataProps["CARDS_MXN"].Cantidad + ele[1];
        }
        if (ele[0] == "VISA_USD" || ele[0] == "MACA_USD") {
          dataProps["CARDS_USD"].Cantidad =
            dataProps["CARDS_USD"].Cantidad + ele[1];
        }

        dataProps[ele[0]] = {
          Nombre: this.getPayMethods[ele[0]].Nombre,
          Cantidad: ele[1],
          Moneda: this.getPayMethods[ele[0]].Moneda,
        };
      });
      return dataProps;
    },

    baseData() {
      let baseData = this.dataEdit;
      // console.log(baseData, "basedata");
      return baseData;
    },

    ventas() {
      let ventas = this.dataEdit.Vnts ? this.dataEdit.Vnts : {};
      return ventas;
    },

    filteredVentasEntries() {
      const ventasObj = this.ventas || {};
      const q = (this.searchVenta || "").toString().toLowerCase().trim();
      let entries = Object.entries(ventasObj);

      if (this.ventasFilter === "venta") {
        entries = entries.filter(([, item]) => Number(item) === 1);
      } else if (this.ventasFilter === "devolucion") {
        entries = entries.filter(([, item]) => Number(item) !== 1);
      }

      if (q) {
        entries = entries.filter(([key]) =>
          key.toString().toLowerCase().includes(q),
        );
      }

      return entries;
    },

    compareCounts() {
      let baseData = this.$pgsHelper.cloneObj(this.dataEdit);
      let sistema = this.$pgsHelper.cloneObj(baseData.Cnts.Ttl);
      let props = baseData?.Cnts?.Pps
        ? this.$pgsHelper.cloneObj(baseData.Cnts.Pps)
        : {};
      let montos = baseData?.Montos
        ? this.$pgsHelper.cloneObj(baseData.Montos)
        : {};
      let cuadreOk = 0;
      let cuadre = {};
      let totalTarjetas = sistema["VISA_MXN"] + sistema["MACA_MXN"];
      sistema["CARDS_MXN"] = totalTarjetas;
      let totalTarjetasUSD = sistema["VISA_USD"] + sistema["MACA_USD"];
      sistema["CARDS_USD"] = totalTarjetasUSD;

      sistema["RETIROS_MXN"] = sistema["Vales"]?.monedas.MXN || 0;

      sistema["RETIROS_USD"] = sistema["Vales"]?.monedas.USD || 0;

      let arrayContadores = Object.entries(sistema);
      arrayContadores.forEach((cont) => {
        let propinas = 0;
        let fondo = 0;
        let cambio = 0;

        if (cont[0] == "EFVO_MXN") {
          fondo = baseData?.Cnts?.Fdo?.MXN || 0;
          cambio = baseData?.Cnts?.Cmb?.MXN || 0;
        }

        if (baseData?.Cnts?.Pps) {
          propinas = this.propinasFullData[cont[0]]?.Cantidad || 0;
        }
        let contadorCapturado = montos[cont[0]]?.Total || 0;
        let diferencia =
          Number(contadorCapturado) - Number(cont[1] + propinas - cambio);
        if (
          this.getShowMp(
            cont[0],
            Number(cont[1]),
            Number(contadorCapturado),
            diferencia,
          )
        ) {
          if (diferencia < 0) {
            cuadreOk++;
          }
        }

        cuadre[cont[0]] = {
          Fondo: fondo,
          Cambio: cambio,
          Propinas: propinas,
          Clave: cont[0],
          Nombre: this.getCountName(cont[0]).Nombre,
          Sistema: Number(cont[1]) - Number(cambio),
          Diferencia: diferencia,
          Contador: Number(contadorCapturado),
          order: this.getOrderMp(cont[0]),
          show: this.getShowMp(
            cont[0],
            Number(cont[1]),
            Number(contadorCapturado),
            diferencia,
          ),
        };
      });
      let ordered = this.$_.orderBy(cuadre, ["order", "Nombre"], "asc");
      return {
        data: ordered,
        rawData: cuadre,
        ok: cuadreOk > 0 ? false : true,
      };
    },
    getPayMethods() {
      const pagos = {};
      const snapshot = this.$pgsHelper.cloneObj(
        this.$store.getters.getPDVPagosTipos,
      );
      snapshot.forEach((pago) => {
        if (pago.Moneda == "All") {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            pagos[pago.id + "_" + tipo.id] = {
              id: pago.id + "_" + tipo.id,
              Nombre: pago.Nombre + " " + tipo.Nombre,
              Moneda: tipo.id,
            };
          });
        } else if (pago.Moneda == "None") {
          pagos[pago.id] = { id: pago.id, Nombre: pago.Nombre };
        } else {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id == pago.Moneda) {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
                Moneda: tipo.id,
              };
            }
          });
        }
      });

      return pagos;
    },
  },
  methods: {
    extractChanges(
      logsArray,
      parentFecha = null,
      parentResponsable = null,
      processedChanges = new Map(),
    ) {
      let logs = [];

      logsArray.forEach((log) => {
        const fecha = moment(log.f).format("YYYY-MM-DD HH:mm");
        const responsable = log.u.n;

        log.c.forEach((change) => {
          const uniqueKey = `${fecha}-${responsable}-${change.p}-${change.b}-${change.a}`;

          // revisar que no tenga duplicados
          if (processedChanges.has(uniqueKey)) return;

          processedChanges.set(uniqueKey, true);

          // si tenemos un objeto en el después, extraemos sus cambios
          if (change.a?.c) {
            logs = logs.concat(
              this.extractChanges(
                [change.a],
                fecha,
                responsable,
                processedChanges,
              ),
            );
            //si no tiene, simplemente pushear
          } else {
            const isProp = change.p.split(".")[2];
            const tipo = isProp == "Ttl" ? "Pago" : "Propina";
            logs.push({
              fecha: parentFecha || fecha,
              responsable: parentResponsable || responsable,
              cambios: {
                antes: change.b,
                despues: change.a,
                k: change.k,
                tipo: tipo,
                montoModificado: change.p.split(".")[3],
              },
            });
          }
        });
      });

      return logs;
    },

    saveData() {
      let dataToSend = {
        turnoId: this.dataEdit.id,
        Montos: this.dataEdit.Montos,
      };

      this.$swal({
        title: "Deseas guardar los cambios?",
        text: "Los pagos editados serán modificados",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Turnos-modificarCierre", dataToSend)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Datos guardados",
              "Los datos fueron guardados exitosamente",
              "success",
            );

            this.showModal = false;
            this.$emit("closeAndReload");
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },
    editarValor(key) {
      this.dataEdit.Montos[key].Total = Number(this.inputValor);
      this.showEditForm = false;
    },
    imprimirElemento() {
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      var ventana = window.open("", "PRINT");
      ventana.document.write("<html><head><title>Ticket de corte</title>");
      ventana.document.write(stylesHtml); //Cargamos otra hoja, no la normal
      ventana.document.write("</head><body >");
      ventana.document.write(this.$refs.corte.$el.innerHTML);
      ventana.document.write("</body></html>");
      ventana.document.close();
      ventana.focus();
      ventana.onload = function () {
        ventana.print();
        ventana.close();
      };
      return true;
    },
    getOrderMp(mp) {
      if (mp == "EFVO_MXN") {
        return 1;
      } else if (mp == "EFVO_USD") {
        return 2;
      } else if (mp == "CARDS_MXN") {
        return 3;
      } else if (mp == "CARDS_USD") {
        return 4;
      } else if (mp == "AMEX_MXN") {
        return 6;
      } else if (mp == "AMEX_USD") {
        return 6;
      } else {
        return 1000;
      }
    },
    getShowMp(mp, sistema, contador, dif) {
      if (
        mp == "VISA_MXN" ||
        mp == "VISA_USD" ||
        mp == "MACA_USD" ||
        mp == "MACA_MXN" ||
        mp == "cambio" ||
        mp == "Fondo" ||
        mp == "Propinas" ||
        mp == "MNDR_MXN" ||
        mp == "CNTA" ||
        mp == "Vales"
      ) {
        return false;
      } else if ((sistema == 0) & (contador == 0) & (Number(dif) == 0)) {
        return false;
      } else {
        return true;
      }
    },

    getCountName(claveCount) {
      var claves = claveCount.split("_");
      let pagos = this.$pgsHelper.cloneObj(this.getPDVPagosTipos);
      pagos.push({
        Nombre: "Visa/Mastercard",
        id: "CARDS",
      });
      pagos.push({
        id: "RETIROS",
        Nombre: "Vales retiro",
      });
      let TipoPago = this.$pgsHelper.getById(pagos, "id", claves[0]);

      let Moneda = this.$pgsHelper.getById(
        this.getPDVMonedasLista,
        "id",
        claves[1],
      );
      return {
        Nombre: TipoPago.Nombre + " - " + (Moneda ? Moneda.Nombre : ""),
        TipoPago: TipoPago,
        Moneda: Moneda,
      };
    },
  },
  beforeMount: function () {},
  mounted: async function () {},
};
</script>
